import styled from "styled-components";
import theme from "../../../Styles/theme";


export const Container = styled.div`
    
border-radius: 0.25rem;
`;

export const DivX = styled.div`
    text-align: right;
`;



export const Title = styled.h1`
    color: ${theme.colors.dark};
    font-size:max(1vw + 8px);
    margin-bottom:2vh;
`;

export const Message = styled.span`
   color: ${theme.colors.dark}; 
   font-size:max(0.6vw +  6px);
`;

